import { ArrowRight, Cpu, MapPin, Network, ShieldCheck } from "lucide-react";

export function Hero({ content }) {
  const { heroPanels, hero, snapshot } = content;
  const facts = snapshot?.facts || [];
  const heroMetrics = [
    { icon: ShieldCheck, label: facts[0]?.label || "Founded", value: facts[0]?.value || "2009" },
    { icon: Cpu, label: facts[3]?.label || "Authorized Lines", value: facts[3]?.value || hero.domains?.[0] },
    { icon: MapPin, label: facts[2]?.label || "Coverage", value: facts[2]?.value || hero.domains?.[1] },
  ];

  return (
    <section id="top" className="hero-section" data-testid="hero-section">
      <div className="hero-panels" aria-hidden="true" data-testid="hero-visual-panels">
        {heroPanels.map((panel, index) => (
          <div
            key={panel.title}
            className="hero-panel"
            data-testid={`hero-panel-${index + 1}`}
            style={{ backgroundImage: `url(${panel.image})` }}
          >
            <div className="hero-panel-label" data-testid={`hero-panel-label-${index + 1}`}>
              <span>{panel.label}</span>
              <strong>{panel.title}</strong>
            </div>
          </div>
        ))}
      </div>

      <div className="hero-overlay" />
      <div className="hero-shell" data-testid="hero-corporate-shell">
        <div className="hero-content">
          <p className="overline" data-testid="hero-overline">{hero.overline}</p>
          <h1 data-testid="hero-headline">{hero.headline}</h1>
          <p className="hero-company" data-testid="hero-company-name">{hero.company}</p>
          <p className="hero-subheadline" data-testid="hero-subheadline">
            {hero.subheadline}
          </p>
          <p className="hero-description" data-testid="hero-description">
            {hero.description}
          </p>

          <div className="hero-domains" data-testid="hero-business-domains">
            {heroPanels.map((panel) => (
              <span key={panel.title} data-testid={`hero-domain-${panel.title.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
                {panel.title}
              </span>
            ))}
          </div>

          <div className="hero-actions" data-testid="hero-cta-group">
            <a className="btn btn-primary" href="#solutions" data-testid="hero-explore-solutions-button">
              {hero.ctas[0]} <ArrowRight size={16} aria-hidden="true" />
            </a>
            <a className="btn btn-secondary" href="#inquiry" data-testid="hero-contact-us-button">
              {hero.ctas[1]}
            </a>
          </div>
        </div>

        <aside className="hero-tech-panel" data-testid="hero-tech-panel">
          <div className="hero-tech-image" style={{ backgroundImage: `url(${heroPanels[0]?.image})` }} data-testid="hero-tech-image" />
          <div className="hero-tech-card" data-testid="hero-tech-card">
            <div className="hero-tech-card-heading" data-testid="hero-tech-card-heading">
              <Network size={20} aria-hidden="true" />
              <span>{hero.company}</span>
            </div>
            <div className="hero-metric-grid" data-testid="hero-metric-grid">
              {heroMetrics.map(({ icon: Icon, label, value }, index) => (
                <div className="hero-metric" key={`${label}-${index}`} data-testid={`hero-metric-${index + 1}`}>
                  <Icon size={18} aria-hidden="true" />
                  <span data-testid={`hero-metric-label-${index + 1}`}>{label}</span>
                  <strong data-testid={`hero-metric-value-${index + 1}`}>{value}</strong>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}